import { render } from "./App.vue?vue&type=template&id=5335bcb1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/css/index.less?vue&type=style&index=0&lang=less"

import exportComponent from "E:\\Workspace\\daifu\\daifu_channel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__